import React from 'react';
import { Spinner } from '@fluentui/react';
import { Formik } from 'formik';
import { useParams } from 'react-router-dom';
import { 
    validationSchema, mapInitialValues, route, basicInfoFields, basePath,
    successMsg, setErrorMsg, rootCss, unsavedMsg, onOldSiteOptions,
 } from '../Helpers/CopyAndFunctions';
import useDataState from '../../../../Util/useDataState';
import useHandleSave from '../../../../Util/useHandleSave';
import FormStepWrapper from '../../../../Forms/FormStepWrapper';
import BasicInfoStep from '../../../../Forms/Steps/BasicInfoStep';
import ChoiceGroup from '../../../../Forms/ChoiceGroup';
import FeatureSummary from '../../../../Util/FeatureSummary';

const WizardPage = () => {
    const { redirectId: idFromParams } = useParams();
    const {
        data: redirectData,
        isReady,
        submitForm,
        showSuccess,
        showError,
        setShowError,
        setShowSuccess,
    } = useDataState(idFromParams, route, basePath);

    if (!isReady) {
        return <Spinner className="absolute-center" text="Loading Redirects Settings..." />;
    }

    return (
        <Formik
            validateOnMount={true}
            initialValues={mapInitialValues(redirectData)}
            onSubmit={async (values, { resetForm }) => {
                if (!values.redirectId) values.redirectId = 0;
                
                await submitForm({ data: values }, resetForm, 'redirectId');
            }}
            isInitialValid={false}
            validationSchema={validationSchema}
        >
            {({ errors, values, isValid, handleSubmit }) => {
                const handleSave = useHandleSave(setShowError);

                return values ? (
                    <>
                        <FormStepWrapper
                            handleSave={() => handleSave(isValid, handleSubmit)}
                            showSuccess={showSuccess}
                            showError={showError}
                            successMessage={successMsg}
                            errorMessage={setErrorMsg(showError, errors)}
                            unsavedMsg={unsavedMsg}
                            rootCss={rootCss}
                            showNavigation={false}
                            setShowSuccess={setShowSuccess}
                            setShowError={setShowError}
                        >
                            <BasicInfoStep fields={basicInfoFields} />
                            <ChoiceGroup label="On Old Site" options={onOldSiteOptions} name="onOldSite" />
                        </FormStepWrapper>
                        <FeatureSummary
                            label="About Redirects"
                            summary="Create or edit URL redirects to forward users from one URL path to another. Set the source path and destination URL, and indicate whether this redirect is from the old site. Redirects help maintain SEO value and ensure users reach the correct content after URL changes."
                        />
                    </>
                    ) : null;
            }}
        </Formik>
    );
};

export default WizardPage;
